import { Link, useLocation } from "react-router-dom";
import { useState, useCallback } from "react";

export default function Navbar() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;
  
  const toggleMenu = useCallback(() => {
    setMobileMenuOpen(prev => !prev);
  }, []);
  
  const closeMenu = useCallback(() => {
    setMobileMenuOpen(false);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <img
            src="/logo.png"
            alt="cek-resi.net"
            className="navbar-logo"
            width="40"
            height="40"
            decoding="async"
          />
          <span className="navbar-title">cek-resi.net</span>
        </Link>

        <button 
          className={`navbar-toggle ${mobileMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>

        <div className={`navbar-menu ${mobileMenuOpen ? "open" : ""}`}>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${isActive("/") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">🏠</span>
                <span className="nav-label">Beranda</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/kurir"
                className={`nav-link ${isActive("/kurir") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">📦</span>
                <span className="nav-label">Cek Resi</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/deteksi-otomatis"
                className={`nav-link ${isActive("/deteksi-otomatis") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">🔍</span>
                <span className="nav-label">Deteksi Otomatis</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/ongkir"
                className={`nav-link ${isActive("/ongkir") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">💰</span>
                <span className="nav-label">Cek Ongkir</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/kodepos-kelurahan"
                className={`nav-link ${location.pathname.startsWith("/kodepos") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">🧭</span>
                <span className="nav-label">Kode Pos</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/blog"
                className={`nav-link ${isActive("/blog") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">📝</span>
                <span className="nav-label">Blog</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/tentang-kontak"
                className={`nav-link ${isActive("/tentang-kontak") ? "active" : ""}`}
                onClick={closeMenu}
              >
                <span className="nav-icon">ℹ️</span>
                <span className="nav-label">Tentang & Kontak</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
